import { isEmpty, map } from 'lodash';
import React from 'react';
import { useSelector } from 'react-redux';
import { PP } from '../../../common/analytics/sourceTypes';
import config from '../../../common/config';
import { formatResource } from '../../../common/helpers/localization/contentResourceHelper';
import { getPostItems } from '../../../common/helpers/ui/dataFilter';
import projectResource from '../../../locales/th/project.json';
import Card from '../../card/Card';
import {
  ProjectArticlesContent,
  ProjectArticlesTitle,
  ProjectArticlesWrapper,
  Wrapper,
} from './ProjectArticles.style';
import { getArticleTypeInGA } from '../../../common/analytics/helpers/articleTypeHelper';
import { trackRelatedArticle } from '../../../common/analytics/analyticsTracker';
import { WholeState } from '../../../store/common/type';
import { Article } from '../../../lib/propertyTypes';
import { AnalyticsProject } from '../../../common/analytics/interfaces/analyticsProject';

interface ProjectArticlesProps {
  id?: number;
  projectData: AnalyticsProject;
  projectName: string;
  projectArticles?: { items: Article[] };
  sect?: string[];
}
const ProjectArticles: React.FC<ProjectArticlesProps> = ({
  projectData,
  projectName,
  projectArticles,
}) => {
  const readMoreText = formatResource(projectResource.readMore, {
    projectName: projectName,
  });
  const projectArticleData = getPostItems(projectArticles);
  const userInfo = useSelector((state: WholeState) =>
    state !== undefined ? state.common.user : {},
  );

  const scrollToAnchor = () => {
    if (config.isBrowser && !isEmpty(window.location.hash)) {
      setTimeout(() => {
        const anchorElement = document.getElementById('project-read-more');
        if (anchorElement) {
          anchorElement.scrollIntoView();
        }
      }, 800);
    }
  };

  scrollToAnchor();

  return (
    !isEmpty(projectArticleData) && (
      <ProjectArticlesWrapper>
        <div id="project-read-more">
          <ProjectArticlesTitle>{readMoreText}</ProjectArticlesTitle>
          <ProjectArticlesContent>
            {map(projectArticleData, (item, i) => {
              const articleTypeInGA = getArticleTypeInGA(
                item.postCategory,
                item.videoType,
              );

              return (
                <Wrapper key={i} className="wrapper">
                  <Card
                    isOnProjectPage
                    {...item}
                    className={'card'}
                    clickOnCardTrack={() =>
                      trackRelatedArticle(
                        userInfo,
                        { ...item, articleTypeInGA },
                        projectData,
                        PP.PAGE,
                      )
                    }
                    lazyLoad={true}
                  />
                </Wrapper>
              );
            })}
          </ProjectArticlesContent>
        </div>
      </ProjectArticlesWrapper>
    )
  );
};

export default ProjectArticles;
